import { render, staticRenderFns } from "./_footer.vue?vue&type=template&id=d3ecd10c&lang=pug&"
import script from "./_footer.vue?vue&type=script&lang=js&"
export * from "./_footer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports